import { inject, Injectable, signal } from "@angular/core";

import { ViewsBaseFilter } from "@bitwarden/web-vault/app/gloss/views/views-control/views-customize/views-base.filter";
import { CalculationTodayStoreService } from "@bitwarden/web-vault/app/services/store/calculation-today/calculation-today.store.service";
import {
  AllowedMainFilterType,
  CountryMainFilterType,
  MainFilter,
} from "@bitwarden/web-vault/app/models/types/filter.types";
import { Observable } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root",
})
export class ViewsTodayFilter extends ViewsBaseFilter {
  filter = signal<MainFilter<CountryMainFilterType>>(null);
  filterObservable$: Observable<MainFilter<CountryMainFilterType>> = toObservable(this.filter);

  constructor() {
    const calculationTodayStoreService = inject(CalculationTodayStoreService);
    super(calculationTodayStoreService);
  }
}
